import { gql } from '@apollo/client';

export const GET_ANNOUNCEMENTS = gql`
  query ANNOUNCEMENT_SERVICE_getAnnouncements {
    getAnnouncements {
      id
      title
      type
      sponsorId
      description
      link
      from
      to
      roles
      archived
    }
  }
`;
